import { ApiResourceBaseClass as s } from "./baseApiCalls.js";
const t = "geocoding";
class n extends s {
  /**
   * Fetches geocoding data based on the provided query parameters.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/geocoding`
   *
   * @param {GeocodingParams} queryParams - The parameters to use for geocoding lookup.
   * @returns {Promise<GeocodingType>} A promise that resolves to the geocoding data.
   */
  getGeocoding = async (e) => {
    const { data: o } = await this.get(t, e);
    return o;
  };
}
export {
  t as GEOCODING_RESOURCE_URI,
  n as Geocoding
};
